import React from "react"
import withHooks from "../../Common/jsx/WithHooks"
import { Tab, Tabs } from "react-bootstrap"
import GGPlantsList from "./GGPlantsList"
import GGPlantsPeriods from "./GGPlantsPeriods"
import GGPlantsFellowships from "./GGPlantsFellowships"

class GgPlantsManager extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.state = {}

    this.state = {
      isReadyToRender: false,
      pageType: this.props.pageType || this.props.entityId !== undefined ? "list_plants" : "list_plants",
    }
    this.dMgr.debug("init_state:", this.state)
  }

  componentDidMount() {
    this.props.setSplashFilterBrightness(50)
  }

  render() {
    this.dMgr.rendering()

    let toRender

    toRender = (
      <Tabs defaultActiveKey={this.state.pageType} id="fill-tab-example" fill data-bs-theme="dark">
        {/* <Tab eventKey="home" title="Accueil">
          Tab content for Home
        </Tab> */}
        <Tab eventKey="list_plants" title="Plantes">
          <GGPlantsList entityType="plant" entityId={this.props.entityId}></GGPlantsList>
        </Tab>
        <Tab eventKey="all_periods" title="Périodes">
          <GGPlantsPeriods key="graphPeriod-all" />
        </Tab>
        {/* <Tab eventKey="fellows" title="Compagnonnage">
          <GGPlantsFellowships />
        </Tab> */}
      </Tabs>
    )

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(GgPlantsManager)
